import * as React from "react";
import {FormGroupProps} from "../common/props/FormGroupProps";
import FormGroup from "../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DatePickerComponent from "../ui/datepicker/DatePickerComponent";
import {Option} from "ts-option";
import {LabelableProps} from "../common/props/LabelableProps";
import moment = require("moment");

type Props = FormGroupProps<moment.Moment> & LabelableProps

export default class DatePickerFormGroup extends React.Component<Props, {}> {

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().orNull}
					   customClass={"c-date-picker-form-group"}>
				<DatePickerComponent value={this.props.field.getOptionalValue()}
									 onChange={this.onChange}/>
			</FormGroup>
		)
	}

	onChange = (date: Option<moment.Moment>) => {
		this.props.onChange(this.props.field.updateValue(date));
	}
}